var keyMirror = require('keymirror');

module.exports = keyMirror({
    ADMIN_CHECK: null,
    NOT_ADMIN: null,
    GET_CONNECTED_PAGES:null
});